import { render, staticRenderFns } from "./alarmAction.vue?vue&type=template&id=ef770972"
import script from "./alarmAction.vue?vue&type=script&lang=js"
export * from "./alarmAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports